/* eslint-disable max-len */

export const AddImageIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4043_9939"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4043_9939)">
        <path
          // eslint-disable-next-line max-len
          d="M8.33333 35C7.41667 35 6.63194 34.6736 5.97917 34.0208C5.32639 33.3681 5 32.5833 5 31.6667V8.33333C5 7.41667 5.32639 6.63194 5.97917 5.97917C6.63194 5.32639 7.41667 5 8.33333 5H21.6667C22.1389 5 22.5347 5.15972 22.8542 5.47917C23.1736 5.79861 23.3333 6.19444 23.3333 6.66667C23.3333 7.13889 23.1736 7.53472 22.8542 7.85417C22.5347 8.17361 22.1389 8.33333 21.6667 8.33333H8.33333V31.6667H31.6667V18.3333C31.6667 17.8611 31.8264 17.4653 32.1458 17.1458C32.4653 16.8264 32.8611 16.6667 33.3333 16.6667C33.8056 16.6667 34.2014 16.8264 34.5208 17.1458C34.8403 17.4653 35 17.8611 35 18.3333V31.6667C35 32.5833 34.6736 33.3681 34.0208 34.0208C33.3681 34.6736 32.5833 35 31.6667 35H8.33333ZM28.3333 11.6667H26.6667C26.1944 11.6667 25.7986 11.5069 25.4792 11.1875C25.1597 10.8681 25 10.4722 25 10C25 9.52778 25.1597 9.13194 25.4792 8.8125C25.7986 8.49306 26.1944 8.33333 26.6667 8.33333H28.3333V6.66667C28.3333 6.19444 28.4931 5.79861 28.8125 5.47917C29.1319 5.15972 29.5278 5 30 5C30.4722 5 30.8681 5.15972 31.1875 5.47917C31.5069 5.79861 31.6667 6.19444 31.6667 6.66667V8.33333H33.3333C33.8056 8.33333 34.2014 8.49306 34.5208 8.8125C34.8403 9.13194 35 9.52778 35 10C35 10.4722 34.8403 10.8681 34.5208 11.1875C34.2014 11.5069 33.8056 11.6667 33.3333 11.6667H31.6667V13.3333C31.6667 13.8056 31.5069 14.2014 31.1875 14.5208C30.8681 14.8403 30.4722 15 30 15C29.5278 15 29.1319 14.8403 28.8125 14.5208C28.4931 14.2014 28.3333 13.8056 28.3333 13.3333V11.6667ZM18.75 26.6667L15.6667 22.5417C15.5 22.3194 15.2778 22.2083 15 22.2083C14.7222 22.2083 14.5 22.3194 14.3333 22.5417L11 27C10.7778 27.2778 10.75 27.5694 10.9167 27.875C11.0833 28.1806 11.3333 28.3333 11.6667 28.3333H28.3333C28.6667 28.3333 28.9167 28.1806 29.0833 27.875C29.25 27.5694 29.2222 27.2778 29 27L24.4167 20.875C24.25 20.6528 24.0278 20.5417 23.75 20.5417C23.4722 20.5417 23.25 20.6528 23.0833 20.875L18.75 26.6667Z"
          fill="#009EFA"
        />
      </g>
    </svg>
  );
};
